import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { Buttton } from "../../components";
import ListGroup from "react-bootstrap/ListGroup";
import { Link, useLocation, } from "react-router-dom";
const Footer = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const pathsToShowFooter = [
        "/",
        "/doctor/terms-and-conditions",
        "/doctor/privacy-policy",
        "/patient",
        "/doctor",
        "/admin"
    ];

    if (!pathsToShowFooter.includes(location.pathname)) {
        return null;
    }


    return (
        <footer className="dfooter">
            <Container>
                <Row className="dfooter-row">
                    <Col lg={5} md={5} sm={12}>
                        <h2 className="exado-title-five">
                            {t("doctor.footer.are_you_in_conflict")} <br />
                            {t("doctor.footer.reach_out_to_us")}
                        </h2>

                        <Buttton.Buttton
                            children={t("contact_us")}
                            className="btn-solid-Aqua_Teal"
                        />
                    </Col>
                    <Col lg={{ span: 5, offset: 2 }} md={{ span: 4, offset: 3 }}>
                        <Row>
                            <Col lg={4} md={12} className="ex-col">
                                <h3 className="exado-title-three">
                                    {t("doctor.footer.quick_links")}
                                </h3>
                                <ListGroup className="dfooter-lgrp">
                                    <ListGroup.Item className="exado-title-six">
                                        {t("doctor.header.nav.how_its_works")}
                                    </ListGroup.Item>
                                    <ListGroup.Item className="exado-title-six">
                                        {t("doctor.header.nav.payment_plan")}
                                    </ListGroup.Item>
                                    <ListGroup.Item className="exado-title-six">
                                        {t("doctor.header.nav.team")}
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col>
                            <Col lg={4} md={12} className="ex-col">
                                <h3 className="exado-title-three">
                                    {t("doctor.footer.follow_us")}
                                </h3>
                                <ListGroup className="dfooter-lgrp">
                                    <ListGroup.Item className="exado-title-six">
                                        {t("facebook")}
                                    </ListGroup.Item>
                                    <ListGroup.Item className="exado-title-six">
                                        {t("linkedin")}
                                    </ListGroup.Item>
                                    <ListGroup.Item className="exado-title-six">
                                        {t("twitter")}
                                    </ListGroup.Item>
                                    <ListGroup.Item className="exado-title-six">
                                        {t("youtube")}
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col>
                            <Col lg={4} md={12} className="ex-col">
                                <h3 className="exado-title-three">
                                    {t("doctor.footer.contact")}
                                </h3>
                                <ListGroup className="dfooter-lgrp">
                                    <ListGroup.Item className="exado-title-six">
                                        info@exado.eu
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <div className="dfooter-blk">
                    <div className="dfooter-sub-blk">
                        <Link to="/doctor/terms-and-conditions" className="exado-title-six">{t("terms_condition")}</Link>
                        <Link to="/doctor/privacy-policy" className="exado-title-six">{t("privacy_policy")}</Link>
                        <Link to="/doctor/FAQs" className="exado-title-six">{t("FAQs")}</Link>
                        <h5 className="exado-title-six">{t("imprint")}</h5>
                        <h5 className="exado-title-six">
                            {t("all_rights_reserved_to_exado")}
                        </h5>
                    </div>
                    <div>
                        <h4 className="exado-title-three">Exado</h4>
                    </div>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;
